
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
Vue.prototype.$unread_messages = window.unread_messages;
Vue.prototype.$unread_notifications = window.unread_notifications;
Vue.prototype.$unread_support_topics = window.unread_support_topics;
Vue.prototype.$is_impersonating = window.is_impersonating;

Vue.prototype.$available_orders = window.available_orders;
Vue.prototype.$confirmation_orders = window.confirmation_orders;
Vue.prototype.$current_orders = window.current_orders;
Vue.prototype.$revision_orders = window.revision_orders;
Vue.prototype.$delivered_orders = window.delivered_orders;
Vue.prototype.$disputed_orders = window.disputed_orders;

Vue.prototype.$disciplines = window.disciplines;
Vue.prototype.$qualities = window.qualities;
Vue.prototype.$qualitiesDescription = window.qualitiesDescription;
Vue.prototype.$deadlines = window.deadlines;
Vue.prototype.$statuses = window.statuses;
Vue.prototype.$types = window.types;
Vue.prototype.$formats = window.formats;
Vue.prototype.$now = window.now;
Vue.prototype.$config = window.config;



/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

//Pages
// Vue.component('testimonials', require('./components/HomePage/Testimonials.vue'));
Vue.component('header-buttons', require('./components/App/Header/Buttons.vue').default);
Vue.component('header-mobile-right-sidebar', require('./components/App/Header/MobileRightSidebar.vue').default);


Vue.component('reviews', require('./components/Pages/Home/Reviews.vue').default);
Vue.component('pricing', require('./components/Pages/Pricing/Pricing.vue').default);
Vue.component('website-features-grid', require('./components/Pages/Includes/WebsiteFeaturesGrid').default);
Vue.component('faq', require('./components/Pages/Faq/Faq.vue').default);
Vue.component('pricing-table', require('./components/Pages/Pricing/PricingTable.vue').default);
Vue.component('price-calculator-sidebar', require('./components/Pages/Pricing/PriceCalculatorSidebar.vue').default);
Vue.component('advantages', require('./components/Pages/Includes/Advantages.vue').default);

Vue.component('order-form-home-page', require('./components/Order/Forms/OrderFormHomePage.vue').default);
Vue.component('order-form', () => import('./components/Order/Forms/OrderForm.vue'));

//Tabs
//Bidding
Vue.component('writers-bidding', () => import('./components/Order/Tabs/Bidding/WritersBidding.vue'));
//Comments
Vue.component('comments', require('./components/Order/Tabs/Comments/Comments.vue').default);
//Transactions and payments
Vue.component('payments', () => import('./components/Order/Tabs/Payments/PaymentsList.vue'));
Vue.component('support-order-tab', () => import('./components/Order/Tabs/Support/SupportTabs.vue'));
Vue.component('transaction-list', () => import('./components/Customer/Transactions/TransactionList.vue'));


Vue.component('flash', require('./components/Flash/Flash.vue').default);


Vue.component('customer-profile-form', require('./components/Customer/CustomerProfileForm.vue').default);
Vue.component('customer-discount-widget', require('./components/Customer/CustomerDiscountWidget.vue').default);


Vue.component('foot', require('./components/Layout/FooterVue.vue').default);
Vue.component('banned-until-flash-message', require('./components/Layout/BannedUntilFlashMessage.vue').default);

Vue.component('messages-notifications', require('./components/MessagesNotifications.vue').default);
Vue.component('events-notifications', require('./components/EventsNotifications.vue').default);

Vue.component('paginator', require('./components/Paginator.vue').default);

Vue.component('order', () => import('./components/Order/Order.vue'));
Vue.component('order-short-information', () => import('./components/Order/Includes/OrderShortInformation.vue'));
Vue.component('order-description', () => import('./components/Order/OrderDescription.vue'));


Vue.component('user-info', () => import('./components/Includes/UserInfo.vue'));
Vue.component('tabs', require('./components/Reusable/Tabs/Tabs.vue').default);
Vue.component('tab', require('./components/Reusable/Tabs/Tab.vue').default);
Vue.component('star-rating', require('./components/Reusable/star-rating.vue').default);
Vue.component('accordion', require('./components/Reusable/Accordion/Accordion.vue').default);
Vue.component('agile', require('./components/Reusable/Carousel/Agile.vue').default);


Vue.component('order-list', () => import('./components/Order/OrderList.vue'));
Vue.component('admin-orders-by-latest-comments', () => import('./components/Admin/Orders/AdminOrdersByLatestComments.vue'));
Vue.component('admin-users-list', () => import('./components/Admin/Customers/AdminUsersList.vue'));
Vue.component('admin-promocodes', () => import('./components/Admin/Promocodes/Promocodes.vue'));
Vue.component('tickets-bar', () => import('./components/Admin/Tickets/Tickets-bar.vue'));
Vue.component('admin-writers-list', () => import('./components/Admin/Writers/AdminWritersList.vue'));


Vue.component('admin-show-user', () => import('./components/Admin/Customers/AdminShowUser.vue'));
Vue.component('admin-writer-payments-dashboard', () => import('./components/Admin/Writers/Payments/Dashboard.vue'));
Vue.component('admin-withdrawals', () => import('./components/Admin/Writers/Payments/Withdrawals/Withdrawals.vue'));
Vue.component('admin-writers-with-requested-payments', () => import('./components/Admin/Payments/Requested/WritersWithRequestedPayments.vue'));
Vue.component('admin-affiliates-with-requested-payments', () => import('./components/Admin/Payments/Requested/AffiliatesWithRequestedPayments.vue'));
Vue.component('admin-supports-with-requested-payments', () => import('./components/Admin/Payments/Requested/SupportsWithRequestedPayments.vue'));
Vue.component('admin-admins-with-requested-payments', () => import('./components/Admin/Payments/Requested/AdminsWithRequestedPayments.vue'));
Vue.component('admin-writer-payouts-history', () => import('./components/Admin/Writers/Payments/PayoutsHistory/WritersPayoutsHistory.vue'));


Vue.component('admin-pages-paper-types-list', () => import('./components/Pages/PaperTypesLandings/Admin/PaperTypesList.vue'));


Vue.component('writer-order-description', () => import('./components/Order/WriterOrderDescription.vue'));
Vue.component('writer-order-list', () => import('./components/Order/WriterOrderList.vue'));
Vue.component('writer-payments-full', () => import('./components/Writer/Payments/WriterPaymentsFull.vue'));
Vue.component('writer-payment-list', () => import('./components/Writer/Payments/WriterPaymentList.vue'));
Vue.component('writer-payouts', () => import('./components/Writer/Payments/WriterPayouts.vue'));
Vue.component('writers-list', () => import('./components/Admin/Writers/WritersList.vue'));
Vue.component('writer-feedback-list', () => import('./components/WriterFeedbackList.vue'));
Vue.component('writer-profile', () => import('./components/Writer/WriterProfile.vue'));
Vue.component('writer-profile-form', () => import('./components/Writer/WriterProfileForm.vue'));
Vue.component('writer-news', () => import('./components/Users/Writers/Dashboard/WriterNews.vue'));
Vue.component('writer-sidebar', () => import('./components/Writer/WriterSidebar.vue'));

Vue.component('admin-supports-list', () => import('./components/Admin/Supports/AdminSupportsList.vue'));
Vue.component('support-profile-form', () => import('./components/Users/Supports/SupportProfileForm.vue'));

Vue.component('admin-affiliates-list', () => import('./components/Admin/Affiliates/AdminAffiliatesList.vue'));
Vue.component('affiliate-sidebar', () => import('./components/Users/Affiliates/AffiliateSidebar.vue'));
Vue.component('affiliate-profile-form', () => import('./components/Users/Affiliates/AffiliateProfileForm.vue'));
Vue.component('affiliate-offers', () => import('./components/Users/Affiliates/Offers/AffiliateOffers.vue'));
Vue.component('affiliate-statistics', () => import('./components/Users/Affiliates/Statistics/AffiliateStatistics.vue'));


Vue.component('inbox', () => import('./components/Inbox.vue'));
Vue.component('messages', () => import('./components/Messages.vue'));
Vue.component('events-notifications-full', () => import('./components/EventsNotificationsFull.vue'));
// Vue.component('events-notifications-full', require('./components/EventsNotificationsFull.vue').default);

//Modals
Vue.component('modals', () => import('./components/Modals/Modals.vue'));

// Vue.component('modals', require('./components/Modals/Modals.vue').default);


//Support
Vue.component('support-topic', () => import('./components/Support/Includes/SupportTopic.vue'));
Vue.component('topics-list', () => import('./components/Support/Includes/TopicsList.vue'));
Vue.component('contact-us', () => import('./components/Pages/ContactUs.vue'));
Vue.component('contact-us-banner', () => import('./components/Pages/Home/ContactUsBanner.vue'));




// import moment from 'moment';
const moment = require('moment-timezone');
import Vuelidate from 'vuelidate';
import StarRating from 'vue-star-rating';
import VModal from 'vue-js-modal';
import Vue from 'vue';
import VCalendar from 'v-calendar';
// import VueCarousel from 'vue-carousel';
// import VueAgile from 'vue-agile'
// import Dropzone from "dropzone"; //eslint-disable-line
//
// Dropzone.autoDiscover = false;
// Vue.use(VueCarousel);
Vue.use(VModal);
Vue.use(Vuelidate);
Vue.use(VCalendar, {
    componentPrefix: 'vc',  // Use <vc-calendar /> instead of <v-calendar />
                           // ...other defaults
});


Vue.filter('fromNow', function(value) {
    if (value) {

        var t = moment.utc(window.now).format('x');
        var o = (moment.utc(value) -  t) / 1e3;


        var days = parseInt(o / 86400);
        o %= 86400;
        var hours = parseInt(o / 3600);
        o %= 3600;
        var minutes = parseInt(o / 60);


        if (days || hours) {
        return days + ' d ' + hours + ' h ';
        } else {
        return minutes + ' min';
        }
    }
});

Vue.filter('fromNowAgo', function(value) {
    if (value) {


        return moment.utc(value).fromNow();
        // return moment.parseZone(value).local().fromNow();
    }
});


Vue.filter('timeAbsolute', function(value) {
    if (value) {
        return moment.parseZone(value).local().format("MMM Do, YYYY, h:mm a")
    }
});

Vue.filter('formatDate', function () {
    return moment(this.data.created_at);
});


// import Gate from './Policies/Gate';
// Vue.prototype.$gate = new Gate(window.user);


import User from './Policies/User';
Vue.prototype.$user = new User(window.user);

Vue.prototype.$eventBus = new Vue();

const app = new Vue({
    el: '#app'
});
